import dayjs from "dayjs";

export const getQuartersForYear = (year: number): string[] => {
    const now = dayjs();
    const currentYear = now.year();
    const currentQuarter = Math.ceil((now.month() + 1) / 3);

    if (year < currentYear) {
        return ["Q1", "Q2", "Q3", "Q4"];
    } else if (year === currentYear) {
        return Array.from({ length: currentQuarter }, (_, i) => `Q${i + 1}`);
    }

    return [];
};